import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PendingIcon from "@mui/icons-material/Pending";

export const BoolNullIcon = ({ value, trueNegative }) => {
  if (value === true) {
    return <CheckCircleIcon color={trueNegative ? "error" : "success"} />;
  }
  if (value === false) {
    return <CancelIcon color={trueNegative ? "success" : "error"} />;
  }
  return <PendingIcon color="disabled" />;
};
